
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"125","height":"120"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 2221"}},[_c('path',{attrs:{"data-name":"Rectangle 2940","fill":"none","d":"M0 0h125v120H0z"}}),_c('path',{attrs:{"data-name":"Path 1357","d":"M125 120V62.75L88.27 26.02A5.994 5.994 0 0077.789 30v22H58.668L32.687 26.02A5.993 5.993 0 0022.207 30v6h-4.211a6 6 0 00-6 6v36a5.977 5.977 0 002.02 4.481l8.237 8.237a5.987 5.987 0 001.974 3.763L49.746 120z","fill":"#3838d2"}}),_c('path',{attrs:{"data-name":"Path 1358","d":"M94 36h-4.211v-6a6 6 0 00-12 0v22H34.207V30a6 6 0 00-12 0v6h-4.211a6 6 0 00-6 6v36a6 6 0 006 6h4.211v6a6 6 0 0012 0V68h43.582v22a6 6 0 0012 0v-6H94a6 6 0 006-6V42a6 6 0 00-6-6z","fill":"#9ea7e9"}})])])
          )
        }
      }
    